import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductsPage from "../pages/products/page";
import AllChinaBuySpreadsheetPage from "../pages/allchinabuy-spreadsheet/page";
import AllChinaBuyReviewPage from "../pages/allchinabuy-review/page";
import AllChinaBuyShippingPage from "../pages/allchinabuy-shipping/page";
import AllChinaBuyCouponPage from "../pages/allchinabuy-coupon/page";
import AllChinaBuyWarehousePage from "../pages/allchinabuy-warehouse/page";
import AllChinaBuyLegitPage from "../pages/allchinabuy-legit/page";
import ArticlePage from "../pages/article/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import PrivacyPage from "../pages/privacy-policy/page";
import TermsPage from "../pages/terms/page";
import DisclaimerPage from "../pages/disclaimer/page";

const langParam = ":lang";

const routes: RouteObject[] = [
  // Redirect root to /en/
  {
    path: "/",
    element: <Navigate to="/en/" replace />,
  },
  // Home page for all languages
  {
    path: `/${langParam}/`,
    element: <Home />,
  },
  // Product catalog page
  {
    path: `/${langParam}/products/`,
    element: <ProductsPage />,
  },
  // Article pages for all languages
  {
    path: `/${langParam}/allchinabuy-spreadsheet/`,
    element: <AllChinaBuySpreadsheetPage />,
  },
  {
    path: `/${langParam}/allchinabuy-review/`,
    element: <AllChinaBuyReviewPage />,
  },
  {
    path: `/${langParam}/allchinabuy-shipping/`,
    element: <AllChinaBuyShippingPage />,
  },
  {
    path: `/${langParam}/allchinabuy-coupon/`,
    element: <AllChinaBuyCouponPage />,
  },
  {
    path: `/${langParam}/allchinabuy-warehouse/`,
    element: <AllChinaBuyWarehousePage />,
  },
  {
    path: `/${langParam}/allchinabuy-legit/`,
    element: <AllChinaBuyLegitPage />,
  },
  // Dynamic article pages for new pillar articles
  {
    path: `/${langParam}/allchinabuy-:articleSlug/`,
    element: <ArticlePage />,
  },
  // Static pages
  {
    path: `/${langParam}/about/`,
    element: <AboutPage />,
  },
  {
    path: `/${langParam}/contact/`,
    element: <ContactPage />,
  },
  {
    path: `/${langParam}/privacy-policy/`,
    element: <PrivacyPage />,
  },
  {
    path: `/${langParam}/terms/`,
    element: <TermsPage />,
  },
  {
    path: `/${langParam}/disclaimer/`,
    element: <DisclaimerPage />,
  },
  // 404
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;